import React from "react";
const IconSquareCheck = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="3" y="3" width="14" height="14" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path d="M3 6.2666H17" stroke="currentColor" strokeWidth="2" />
    <path
      d="M5.7998 11.2203L8.85435 13.7331L14.1998 9.06641"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconSquareCheck;
